/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ docType: NonNullable<unknown> }} Upload_ClassifiedInputs */

const en_upload_classified = /** @type {(inputs: Upload_ClassifiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.docType}`)
};

const pt_br2_upload_classified = /** @type {(inputs: Upload_ClassifiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.docType}`)
};

/**
* | output |
* | --- |
* | "{docType}" |
*
* @param {Upload_ClassifiedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const upload_classified = /** @type {((inputs: Upload_ClassifiedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_ClassifiedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upload_classified(inputs)
	return pt_br2_upload_classified(inputs)
});